/**
 * @fileoverview Entry point to the rewritten Build mode.
 */

// Load and register the Shoelace components we'll be using in this application.
import './components/shoelace';
import './RebuildApp';
import { removeAllChildren } from './dom';

function render() {
  const root = document.getElementById('root');
  removeAllChildren(root);
  root?.append(document.createElement('rebuild-app'));
}

window.addEventListener('load', render);